import styled from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";

export const SplitPageWrapper = styled.div`
	${media.lessThan(breakpoints.ipad)`
	flex-direction: column;
  `};
	${media.greaterThan(breakpoints.ipad)`
	padding: ${({ Padding }) => Padding};
  `};

	& {
		max-width: ${({ maxWidth, theme }) => (maxWidth ? maxWidth : theme.grid.outer)};
		display: flex;
		justify-content: space-between;
	}
`;
